import React, { CSSProperties } from 'react';
import { Arrayable } from 'types/Arrayable';

const contentStyle: CSSProperties = {
  color: '#44565f',
  fontSize: '1.1em',
};

export interface PlainMessageProps {
  messages: Arrayable<string>;
  title: string;
}

export function PlainMessage(props: PlainMessageProps) {
  const { messages: messagesProp, title } = props;
  const messages: string[] = Array.isArray(messagesProp) ? messagesProp : messagesProp.split('\n');

  return (
    <div>
      <h1 style={contentStyle}>{title}</h1>
      {messages.map((message, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={`line-${index}`} style={contentStyle}>
          {message}
          <br />
        </span>
      ))}
    </div>
  );
}
